<template>
  <div
    :class="`formulate-input-element formulate-input-element--${context.class}`"
    :data-type="context.type"
    >
  </div>
</template> >

<script>
// This custom input field is used for text type custom field. It's only
  // purpose is to disable any input fields for the type.
export default {
  props: {
    context: {
      type: Object,
      required: true
    },
  },
  data () {
    return { }
  },
  watch: {
    model () {
    }
  },
  computed: {
    model () {
      return this.context.model
    },
  },
  methods: {
  }
}
</script>
